<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <!--<h2>Manage Super Agents</h2>-->
            <div class="">
              <div class="row">
              <div class="col-3" *ngIf="superAgents.length">
              <ng-select [items]="filterArray" class="ng-select-form col-12"
                         [notFoundText]="'No data available'"
                         [placeholder]="'Filter by Super Agent'"
                         bindLabel="full_name" (change)="getAgents($event)"
                         [(ngModel)]="filter.filterBySuperAgent" [ngModelOptions]="{standalone: true}"
                         bindValue="id">
              </ng-select>
            </div>
            <div class="col-3" >
              <ng-select *ngIf="filter.filterBySuperAgent" [items]="filterStatusArray" class="ng-select-form col-12"
                         [notFoundText]="'No data available'"
                         [placeholder]="'Filter by Status'"
                         bindLabel="name" (change)="getAgents($event, true)"
                         [(ngModel)]="filter.filterByStatus" [ngModelOptions]="{standalone: true}"
                         bindValue="id">
              </ng-select>
            </div>
                <div class="col-3"></div>
                <div class="col-3 float-right">
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('createAgent')">
                    <i class="fa fa-plus"></i> &nbsp;<span>New Agent</span></button>
                </div>
              </div>
            </div>

          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="changeOccured">
              <table id="agents-list" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>S/N</th>
                  
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>State</th>
                  <th>LGA</th>
                  
                  <th>Super Agent</th>
                  
                  <th>Wallet Bal.</th>
                  <th>Action</th>
                  <th>Status</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>State</th>
                  <th>LGA</th>
                  
                  <th>Super Agent</th>
                  
                  <th>Wallet Bal.</th>
                  <th>Action</th>
                  <th>Status</th>

                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let agent of allAgents;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>

                 <td>{{ agent?.first_name }}</td>
                 <td>{{ agent?.last_name }}</td>
                 <td>{{ agent?.email }}</td>
                 <td>{{ agent?.phone_no }}</td>
                 <td>{{ agent?.state?.name }}</td>
                 <td>{{ agent?.lga?.name }}</td>

                 <td><a href="javascript:void(0)" (click)="showMyAgents(agent.super_agent)">{{ agent?.super_agent?.full_name || agent?.super_agent?.first_name }}</a></td>
                 <th>{{ agent?.wallet_balance || 0 | currency: '&#8358;' }}</th>
                  <td>
                    <div>
                      <span role="button" data-balloon="Edit Agent" data-balloon-pos="up" (click)="triggerEdit(agent)">
                        <i class="fa fa-edit text-info"></i>
                      </span>
                      &nbsp;&nbsp;
                      <button role="button" [disabled]="disabled && agentId === agent.id" [attr.data-ballon]="agent.status === 'Active' ? 'Disable Agent' : 'Enable Agent' "
                      data-balloon-pos="up" (click)="toggleAgentStatus(agent)" [ngClass]="agent.status === 'Active' ? 'btn-danger' : 'btn-success' "
                      class="btn btn-sm">
                        {{ agent.status === 'Active' ? 'Disable' : 'Enable'}}
                      </button>

                    </div>
                  </td>

                  <td>
                    <span class="badge badge-info" *ngIf="agent?.status === 'Inactive'">Awaiting Approval</span>
                    <span class="badge badge-success" *ngIf="agent?.status === 'Active'">Approved</span>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Create Super Agent Modal -->

<app-modal [modalId]="'createAgent'" [modalTitle]="modal.title" >
      <form class="form-auth-small" #signupForm="ngForm" (ngSubmit)="createNewAgent()">

        <div class="modal-body">

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label for="first_name" class="control-label ">First Name</label>
                <input type="text" class="form-control" placeholder="First Name"
                       #first_name="ngModel"
                       id="first_name"
                       [(ngModel)]="agent.first_name" [ngModelOptions]="{standalone: true}" required>
                <div class="text-danger" *ngIf="first_name.errors && (first_name.dirty || first_name.touched)">
                  <span class="validation-message" [hidden]="!first_name.hasError('required')">
                    First name is required</span>
                </div>
              </div>
              <div class="form-group">
                <label for="email" class="control-label ">Email</label>
                <input type="email" class="form-control" placeholder="Email"
                       #email="ngModel"
                       id="email"
                       [(ngModel)]="agent.email" [ngModelOptions]="{standalone: true}" [pattern]="EMAIL_VALIDATION" required>
                <div class="text-danger" *ngIf="email.errors && (email.dirty || email.touched)">
                  <span class="validation-message" [hidden]="!email.hasError('required')">
                    Email is required</span>
                  <span class="validation-message" [hidden]="!email.hasError('pattern')">
                    Invalid Email</span>
                </div>
              </div>
              <div class="form-group">
                <!--*ngIf="!activeAgent"-->
                <label for="super_agent" class="control-label ">Select Super Agent</label>
                <ng-select [items]="superAgents" class="ng-select-form" #super_agent="ngModel" required id="super_agent"
                           [notFoundText]="'No data available'"
                           [placeholder]="'Select Super Agent'"
                           bindLabel="full_name"
                           bindValue="unique_code"
                           [multiple]="false"
                           [(ngModel)]="agent.super_agent_code" [ngModelOptions]="{standalone: true}" >
                </ng-select>

                <div class="text-danger" *ngIf="super_agent.errors && (super_agent.dirty || super_agent.touched)">
                  <span class="validation-message" [hidden]="!super_agent.hasError('required')">
                    Super Agent is required</span>
                </div>
              </div>


            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label for="last_name" class="control-label ">Last Name</label>
                <input type="text" class="form-control" placeholder="Last Name"
                       #last_name="ngModel"
                       id="last_name"
                       [(ngModel)]="agent.last_name" [ngModelOptions]="{standalone: true}" required>
                <div class="text-danger" *ngIf="last_name.errors && (last_name.dirty || last_name.touched)">
                  <span class="validation-message" [hidden]="!last_name.hasError('required')">
                    Last name is required</span>
                </div>
              </div>
              <div class="form-group">
                <label for="phone_number" class="control-label ">Phone Number</label>
                <input type="text" class="form-control" placeholder="Phone Number"
                       #phone_number="ngModel"
                       maxlength="11"
                       id="phone_number"
                       [(ngModel)]="agent.phone_no" [ngModelOptions]="{standalone: true}" required>
                <div class="text-danger" *ngIf="phone_number.errors && (phone_number.dirty || phone_number.touched)">
                  <span class="validation-message" [hidden]="!phone_number.hasError('required')">
                    Phone is required</span>
                </div>
              </div>
              <div class="form-group">
                <label for="selectState" class="control-label ">Select State</label>
                <ng-select [items]="allStates" class="ng-select-form" required id="selectState"
                           [notFoundText]="'No data available'"
                           [placeholder]="'Select State'"
                           bindLabel="name"
                           bindValue="id" (change)="filterLGA($event)" [(ngModel)]="agent.state_id" [ngModelOptions]="{standalone: true}"
                           [multiple]="false" >
                </ng-select>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group" *ngIf="stateSelected">
                <label for="selectLGA" class="control-label ">Select LGA</label>
                <ng-select [items]="allLGA" class="ng-select-form" #lga="ngModel" required id="selectLGA"
                           [notFoundText]="'No data available'"
                           [placeholder]="'Select LGA'"
                           bindLabel="name"
                           bindValue="id"
                           [multiple]="false"
                           [(ngModel)]="agent.lga_id" [ngModelOptions]="{standalone: true}" >
                </ng-select>

                <div class="text-danger" *ngIf="lga.errors && (lga.dirty || lga.touched)">
                  <span class="validation-message" [hidden]="!lga.hasError('required')">
                    LGA is required</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" *ngIf="!loaders.saving" [disabled]="first_name.errors || last_name.errors || email.errors || phone_number.errors" class="btn btn-primary">{{modal.btnText}}</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="resetForm()">CLOSE</button>
        </div>
      </form>
</app-modal>
